export default function featureDetectionReducer(state = {}) {
  return state;
}
